import React from "react";

const RestartPositionOnceSystemHasFlattenedDoc = (
    <>
        <p>
            Will try to repeat the trade plan once it has been completed.
        </p>
        <p>
            Ex: Let's say you believe that AAPL will bounce at 450 constantly throughout
            the day. If this is set to true, once your trade plan has completed and the position
            exited, we will try to play the bounce of 450 again.
        </p>
        <p>
            NOTE: We are currently only allowing this setup for setups Break Candle Type and Candle Pattern. We hope
            to continue to expand this functionality in the future.
            {/*NOTE: this could come with side effects, that might or might not be helpful.
            For example, we terminate any system that attempts to bounce if current
            price has already passed bounce price. If your trade plan exits when price is below 450, when we try
            restart the trade plan, it will not pass bounce validation, and terminate. */}
        </p>
    </>
);
export default RestartPositionOnceSystemHasFlattenedDoc;
